import pageBorders from './pageBorders.js';

const pageBorderModule = {
  init(definitions = pageBorders) {
    const container = document.querySelector('.pages-container');
    const strip = container?.querySelector('.pages-inner');
    if (!strip) return;
    const desktop = matchMedia('(min-width: 768px)');
    const pages = Array.from(strip.querySelectorAll(':scope > .page'));
    const entries = [];
    for (const definition of definitions) {
      const index = pages.findIndex(page => page.dataset.id === String(definition.page));
      if (index < 0) continue;
      const border = document.createElement('img');
      border.className = 'page-border';
      border.alt = '';
      border.setAttribute('aria-hidden', 'true');
      border.draggable = false;
      pages[index].after(border);
      entries.push({ definition, page: pages[index], border });
    }
    const update = () => {
      for (const { definition, page, border } of entries) {
        const source = desktop.matches ? definition.desktop : definition.mobile;
        border.hidden = !source;
        if (!source) continue;
        if (border.getAttribute('src') !== source) border.setAttribute('src', source);
        const bounds = (page.querySelector('.filmstrip-stage') || page).getBoundingClientRect();
        border.style.width = desktop.matches ? 'auto' : `${bounds.width}px`;
        border.style.height = desktop.matches ? `${bounds.height}px` : 'auto';
      }
    };
    container.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    desktop.addEventListener('change', update);
    const observer = new ResizeObserver(update);
    observer.observe(container);
    for (const { page } of entries) observer.observe(page);
    update();
  },
};

export default pageBorderModule;